import React from 'react'

const HireMe = () => {
  const whyHireMe = [
  {
    icon: '01',
    title: 'Full-Stack Implementation',
    description: 'Comfortable working across frontend and backend layers including React interfaces, REST APIs, database schemas, and authentication systems.'
  },
  {
    icon: '02',
    title: 'Maintainable Code Practices',
    description: 'Organizes projects using controllers, middleware, and reusable components to keep codebases readable and easy to extend.'
  },
  {
    icon: '03',
    title: 'Real-Time and API Experience',
    description: 'Experience building WebSocket features, protected routes, and structured API endpoints used by multiple client components.'
  },
  {
    icon: '04',
    title: 'Debugging and Issue Resolution',
    description: 'Able to trace errors, read logs, and isolate bugs in both frontend and backend environments.'
  },
  {
    icon: '05',
    title: 'Security Awareness',
    description: 'Implements authentication, token verification, validation, and safe data handling to prevent common application vulnerabilities.'
  },
  {
    icon: '06',
    title: 'Automation and Scripting',
    description: 'Uses Python for data extraction, document processing, and repetitive task automation to reduce manual operational work.'
  },
  {
    icon: '07',
    title: 'Performance Consideration',
    description: 'Optimizes queries, reduces unnecessary re-renders, and manages API calls efficiently for stable application behavior.'
  },
  {
    icon: '08',
    title: 'Team Collaboration',
    description: 'Familiar with Git workflows, version control, and working with shared repositories in a collaborative environment.'
  }
]

  return (
    <section id="hire-me" className="bg-backgroundDark py-12 sm:py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-4xl font-bold mb-4 text-textPrimary">
            How I Contribute
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-primary mx-auto mb-4 sm:mb-6"></div>
          <p className="font-body text-base sm:text-lg text-textSecondary max-w-2xl mx-auto px-4">
            I focus on building reliable features, fixing problems quickly, and supporting team productivity in real development environments.
          </p>
        </div>

        {/* Why Hire Me Section */}
        <div className="mb-12 sm:mb-16">
          <h3 className="font-heading text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-10 text-textPrimary">
            What I Bring to a Team
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8">
            {whyHireMe.map((item, index) => (
              <div key={index} className="bg-accent p-6 rounded-lg hover:bg-accent/80 transition-all duration-300 border border-accent hover:border-primary/30">
                <div className="text-xl font-bold text-primary mb-4 text-center">
                  {item.icon}
                </div>

                <h4 className="font-heading text-base sm:text-lg font-bold mb-3 text-textPrimary leading-tight">
                  {item.title}
                </h4>
                <p className="font-body text-textSecondary text-xs sm:text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default HireMe
